import * as React from 'react'
import Header from './Header'
import Menu from './Menu'
import { useLocation } from "react-router-dom";
import CustomText from '../utilities/CustomDiv';
import { Container } from '@mui/material';


const Layout = (props) => {
    const rota = useLocation()

    return(
    <>
        <div>
            <Header breadcrumb={props.breadcrumb} />
            <Container>
            <div style={{display: 'flex', flexDirection: 'row'}}>
                <Menu />
                <div style={{display: 'flex', flexDirection: 'column', flex: 1, padding: 0}}>
                    <div>
                        { rota.pathname == '/Dashboard' || rota.pathname == '/dashboard' ? null :
                        <>
                            <div style={{height: 1, backgroundColor: '#ff6400', display: 'flex', width: '100%', marginTop: 5, marginLeft: 20}}></div>
                            <div style={{marginTop: 5, marginBottom: 25, padding: 20}}>
                                <CustomText style={{fontSize: 24}}>{props.title}</CustomText>
                            </div>
                        </>
                        }
                    </div>
                    
                    <CustomText style={{display: 'flex', backgroundColor: rota.pathname == '/Dashboard' || rota.pathname == '/dashboard' ? '#ffffff' : '#f7f7f7', borderRadius: 10, padding: 30, marginLeft: 20, flexDirection: 'column'}}>
                        {props.children}
                    </CustomText>
                    
                </div>
            </div>
            </Container>
        </div>
    </>
    )
}

export default Layout